import { useState, useContext, useMemo } from "react"
import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material"
import { NothingToSee } from "../../../empty/Index"
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader"
import { Visibility, DisabledByDefault, CheckBox, ContentCopy } from "@mui/icons-material"
import { rqx } from "../../../../../core/request/API"
import { env } from "../../../../../core/Env"
import { Waypoint } from "react-waypoint"
import { ParsingAmount } from "../../../../../core/validator/Validator"
import { ConfirmationModal } from "../../../../../core/global/Confirmation"
import { ToolContext } from "../../../../../core/context/ToolContext"

export const List = ({ __init, loadMoreData }) => {
	const { setup_state, tool_state } = useContext(ToolContext)
    const { userId } = tool_state
    const { memberList, memberLoader, memberHasMore, memberModals, memberSelected, memberMethod } = setup_state
    const [copied, setCopied] = useState(false);

    const handlerView = (row) => {
		memberModals.set((p) => ({ ...p, form: true }))
		memberSelected.set((p) => ({ ...p, id: row.id  }))
		memberMethod.set('update')
    }

    const handlerDisable = (row) => {
		memberModals.set((p) => ({ ...p, confirmation: true }))
		memberSelected.set((p) => ({ ...p, id: row.id, active: row.active  }))
    }

    const handleClose = () => {
		memberSelected.set((p) => ({ ...p, id: '', active: false  }))
		memberModals.set((p) => ({ ...p, confirmation: false }))
    }

    const handleSaving = async() => {
		memberLoader.set((p) => ({ ...p, statusSaving: true }))
        let body = {
            id: memberSelected.data.id,
            active: memberSelected.data.active === 1 ? 0 : 1,
            data_status: memberSelected.data.active === 1 ? 'IsDeleted' : 'InUse',
            user_id: userId.data,
        }
        const res = await rqx.post(`<<tool>>/${env()}/membership/status_update`, body)
        if (res.message === 'success') {
			await __init(1); // get fresh list from backend
			memberSelected.set((p) => ({ ...p, id: '', active: false  }))
			memberLoader.set((p) => ({ ...p, statusSaving: false }))
			memberModals.set((p) => ({ ...p, confirmation: false }))
        }
    }

    const headerStyle = {
        fontWeight: 'bold',
        padding: '16px',
        borderBottom: '2px solid #444',
        whiteSpace: 'nowrap',
    };

    const bodyStyle = {
        padding: '12px',
        borderBottom: '1px solid #ddd', 
        fontSize: '14px',
        whiteSpace: 'nowrap',
    };
    
    const handlerURL = (row) => {
        window.open(`${process.env.REACT_APP_URL_SHP}/psl/membership?steps=pay&id=${window.btoa(row.id)}`, '_blank')
    }

     const handleCopy = async (link) => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // Reset after 1.5 sec
        } catch (err) {
            console.error('Failed to copy!', err);
        }
    };

	const memoizedMembershipList = useMemo(() => {
		return memberList.data.map((row, idx) => (
			<TableRow key={idx}>
				{console.log('membership')}
				<TableCell sx={bodyStyle}>{memberList.data.length - idx}</TableCell>
				<TableCell sx={{ ...bodyStyle, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.name}</TableCell>
				<TableCell sx={{ ...bodyStyle, whiteSpace: 'nowrap', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis',cursor: 'pointer', color: '#1976d2',textDecoration: 'underline', }}
					onClick={() => handlerURL(row)} 
				>
					{`${process.env.REACT_APP_URL_SHP}/psl/membership?steps=pay&id=${window.btoa(row.id)}`}
				</TableCell>
				<TableCell sx={bodyStyle}>{row.regular_price && row.regular_price !== '0' ? `₱ ${ParsingAmount(row.regular_price)}` : 'N/A'}</TableCell>
				<TableCell sx={bodyStyle}>{row.discount  && row.discount !== '0' ? `₱ ${ParsingAmount(row.discount)}` : 'N/A'}</TableCell>
				<TableCell sx={bodyStyle}>{row.price  && row.price !== '0' ? `₱ ${ParsingAmount(row.price)}` : 'N/A'}</TableCell>
				<TableCell sx={bodyStyle}>{row.active ? 'Active': 'Inactive'}</TableCell>
				<TableCell sx={bodyStyle}>{row.is_exclusive ? 'No': 'Yes'}</TableCell>
				<TableCell sx={{...bodyStyle, textAlign: 'center'}}>
					<Tooltip title="View">
						<IconButton onClick={() => handlerView(row)}>
							<Visibility  sx={{ color: '#81D4FA' }} />
						</IconButton>
					</Tooltip>
					<Tooltip title={row.active === 1 ? "Disable" : "Enable"}>
						<IconButton onClick={() => handlerDisable(row)}>
							{row.active === 1 ? <DisabledByDefault sx={{ color: '#B0BEC5' }} /> : <CheckBox sx={{color: '#80E27E'}} /> } 
						</IconButton>
					</Tooltip>
						<Tooltip title={copied ? "Copied!" : "Copy"} arrow>
						<IconButton onClick={() => handleCopy(`${process.env.REACT_APP_URL_SHP}/psl/membership?steps=pay&id=${window.btoa(row.id)}`)}>
							<ContentCopy sx={{ fontSize: "20px" }}/>
						</IconButton>
					</Tooltip>
				</TableCell>
			</TableRow>
		))
		// eslint-disable-next-line
	}, [memberList.data])

    return (
        <Box display="flex" flexDirection="column" pb="24px" className="overflowY">
            {
                memberLoader.data.list ?
                    <Box width="100%" display="flex" justifyContent="center" alignItems="center" mt={2}>
                        <SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
                    </Box>
                :
                    memberList.data.length === 0 ?
                        <NothingToSee text="No Available Membership" />
                :
                    <TableContainer component={Paper}>
                        <Table stickyHeader>
                            <TableHead sx={{ backgroundColor: "#222", color: "white"  }}>
                                <TableRow>
                                    <TableCell sx={headerStyle}>No.</TableCell>
                                    <TableCell sx={headerStyle}>Membership Name</TableCell>
                                    <TableCell sx={{ ...headerStyle, maxWidth: 250 }}>Membership Reg. Link</TableCell>
                                    <TableCell sx={headerStyle}>Regular Price</TableCell>
                                    <TableCell sx={headerStyle}>Discount</TableCell>
                                    <TableCell sx={headerStyle}>Price</TableCell>
                                    <TableCell sx={headerStyle}>Status</TableCell>
                                    <TableCell sx={headerStyle}>Inclusive</TableCell>
                                    <TableCell sx={{...headerStyle, textAlign: 'center'}}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
								{memoizedMembershipList}
                                {/* {memberList.data.map((row, idx) => (
                                    <TableRow key={idx}>
										{console.log('membership')}
                                        <TableCell sx={bodyStyle}>{memberList.data.length - idx}</TableCell>
                                        <TableCell sx={{ ...bodyStyle, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.name}</TableCell>
                                        <TableCell sx={{ ...bodyStyle, whiteSpace: 'nowrap', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis',cursor: 'pointer', color: '#1976d2',textDecoration: 'underline', }}
                                            onClick={() => handlerURL(row)} 
                                        >
                                            {`${process.env.REACT_APP_URL_SHP}/psl/membership?steps=pay&id=${window.btoa(row.id)}`}
                                        </TableCell>
                                        <TableCell sx={bodyStyle}>{row.regular_price && row.regular_price !== '0' ? `₱ ${ParsingAmount(row.regular_price)}` : 'N/A'}</TableCell>
                                        <TableCell sx={bodyStyle}>{row.discount  && row.discount !== '0' ? `₱ ${ParsingAmount(row.discount)}` : 'N/A'}</TableCell>
                                        <TableCell sx={bodyStyle}>{row.price  && row.price !== '0' ? `₱ ${ParsingAmount(row.price)}` : 'N/A'}</TableCell>
                                        <TableCell sx={bodyStyle}>{row.active ? 'Active': 'Inactive'}</TableCell>
                                        <TableCell sx={bodyStyle}>{row.is_exclusive ? 'No': 'Yes'}</TableCell>
                                        <TableCell sx={{...bodyStyle, textAlign: 'center'}}>
                                            <Tooltip title="View">
                                                <IconButton onClick={() => handlerView(row)}>
                                                    <Visibility  sx={{ color: '#81D4FA' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={row.active === 1 ? "Disable" : "Enable"}>
                                                <IconButton onClick={() => handlerDisable(row)}>
                                                    {row.active === 1 ? <DisabledByDefault sx={{ color: '#B0BEC5' }} /> : <CheckBox sx={{color: '#80E27E'}} /> } 
                                                </IconButton>
                                            </Tooltip>
                                             <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
                                                <IconButton onClick={() => handleCopy(`${process.env.REACT_APP_URL_SHP}/psl/membership?steps=pay&id=${window.btoa(row.id)}`)}>
                                                    <ContentCopy sx={{ fontSize: "20px" }}/>
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))} */}
                            </TableBody>
                        </Table>
						{
							memberHasMore.data && (
								<Waypoint onEnter={loadMoreData}>
									<Box width="100%" display="flex" justifyContent="center" my={2}>
										<SnakeLoader bg="#009F4D" size= "10px" distance= "5px"  />
									</Box>
								</Waypoint>
							)
						}
                    </TableContainer>
            }
            {
                !memberModals.data.form &&
					<>
						{memberModals.data.confirmation && <ConfirmationModal title={`${memberSelected.data.active === 1 ? 'Disable' : 'Enable'} this Membership?`} cancelFunc={handleClose} sendFunc={handleSaving} text={`This Membership will ${memberSelected.data.active === 1 ? 'not' : ''} be available online`} saving={memberLoader.data.statusSaving} saveTxt={memberSelected.data.active === 1 ? 'Disable' : 'Enable'} type={memberSelected.data.active === 1 ? 'disabled' : 'normal'}/>}
					</>
            }
        </Box>
    )
}
